require('./bootstrap');

require('./rSlider');
import Alpine from 'alpinejs';
import mask from '@alpinejs/mask';
import intersect from '@alpinejs/intersect'

Alpine.plugin(intersect)
Alpine.plugin(mask);
tippy('[data-tippy-content]');
